/**
 * Transactions API
 *
 * Contact: support-ucc@cardcenter.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AuthorizationsList } from '../model/authorizationsList';
// @ts-ignore
import { PostingsList } from '../model/postingsList';
// @ts-ignore
import { TransactionDetails } from '../model/transactionDetails';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class TransactionsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Returns all authorizations of accountId
     * @param accountId AccountId from which authorizations are returned
     * @param uCCCorrelationId identifier used for correlating requests
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAuthorizations(accountId: string, uCCCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<AuthorizationsList>;
    public getAuthorizations(accountId: string, uCCCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<HttpResponse<AuthorizationsList>>;
    public getAuthorizations(accountId: string, uCCCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<HttpEvent<AuthorizationsList>>;
    public getAuthorizations(accountId: string, uCCCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<any> {
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling getAuthorizations.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (uCCCorrelationId !== undefined && uCCCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('UCC-Correlation-Id', String(uCCCorrelationId));
        }

        // authentication (BearerRead) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerRead', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json; charset=utf-8'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/transactions/authorizations/${this.configuration.encodeParam({name: "accountId", value: accountId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AuthorizationsList>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get authorizations for one or multiple accounts of one customer.
     * @param accountIds List of AccountIds for which authorizations are returned
     * @param uCCCorrelationId identifier used for correlating requests
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAuthorizationsFromMultipleAccountIds(accountIds: Array<string>, uCCCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<AuthorizationsList>;
    public getAuthorizationsFromMultipleAccountIds(accountIds: Array<string>, uCCCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<HttpResponse<AuthorizationsList>>;
    public getAuthorizationsFromMultipleAccountIds(accountIds: Array<string>, uCCCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<HttpEvent<AuthorizationsList>>;
    public getAuthorizationsFromMultipleAccountIds(accountIds: Array<string>, uCCCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<any> {
        if (accountIds === null || accountIds === undefined) {
            throw new Error('Required parameter accountIds was null or undefined when calling getAuthorizationsFromMultipleAccountIds.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (accountIds) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...accountIds].join(COLLECTION_FORMATS['csv']), 'accountIds');
        }

        let localVarHeaders = this.defaultHeaders;
        if (uCCCorrelationId !== undefined && uCCCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('UCC-Correlation-Id', String(uCCCorrelationId));
        }

        // authentication (BearerRead) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerRead', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json; charset=utf-8'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/transactions/authorizations`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AuthorizationsList>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns cleared transactions of accountId
     * @param accountId AccountId from which cleared transactions are returned
     * @param uCCCorrelationId identifier used for correlating requests
     * @param size maximal size of result list (1..1000)
     * @param page Page number, e.g. 4
     * @param dateType Type of date used for \&#39;fromDate\&#39; and \&#39;toDate\&#39;. (default if type is not set: postingDate).  If both \&#39;fromDate\&#39; and \&#39;toDate\&#39; are not provided, then a default time period is used. For the default time period the \&#39;toDate\&#39; is set to current date.  The \&#39;fromDate\&#39; is set to two years ago at the end of the previous month. If current date is e.g. 2024-10-25, then \&#39;fromDate\&#39; is set to 2022-09-30. The sorting of the returned list of transactions is conducted according to the provided dateType in descending order.
     * @param fromDate Only include postings with date greater than or equal to this date, e.g. 2018-04-10
     * @param toDate Only include postings with date up to or equal to this date, e.g. 2018-06-23
     * @param minAmount Only include postings with a posting amount greater than or equal to this amount. The transaction amount may differ, for instance if it is in a different currency.
     * @param maxAmount Only include postings with a posting amount less than or equal to this amount. The transaction amount may differ, for instance if it is in a different currency.
     * @param includeStatementTransactions If this parameter is not specified or false, then only postings for the given account ID are returned. If true, postings on the statement of this account are also returned. These could be transactions of child accounts for which this is the liable account. If this parameter is true, \&#39;fromDate\&#39; and \&#39;toDate\&#39; must have a value. In case that both \&#39;fromDate\&#39; and \&#39;toDate\&#39; are not provided, the default time period is used. For more details see description of the attribute \&#39;dateType\&#39;.
     * @param merchantCategoryCode Only include postings where the merchant category code is contained in the given array.
     * @param isSettled isSettled indicates whether a posting transaction has been added to an invoice or not. If the query parameter is absent, the query will return all posting transactions, regardless whether it has been settled or not. Note that this query parameter is only applicable to posting transactions, not authorizations
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPostings(accountId: string, uCCCorrelationId?: string, size?: number, page?: number, dateType?: 'postingDate' | 'transactionDate', fromDate?: string, toDate?: string, minAmount?: number, maxAmount?: number, includeStatementTransactions?: boolean, merchantCategoryCode?: Array<number>, isSettled?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<PostingsList>;
    public getPostings(accountId: string, uCCCorrelationId?: string, size?: number, page?: number, dateType?: 'postingDate' | 'transactionDate', fromDate?: string, toDate?: string, minAmount?: number, maxAmount?: number, includeStatementTransactions?: boolean, merchantCategoryCode?: Array<number>, isSettled?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<HttpResponse<PostingsList>>;
    public getPostings(accountId: string, uCCCorrelationId?: string, size?: number, page?: number, dateType?: 'postingDate' | 'transactionDate', fromDate?: string, toDate?: string, minAmount?: number, maxAmount?: number, includeStatementTransactions?: boolean, merchantCategoryCode?: Array<number>, isSettled?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<HttpEvent<PostingsList>>;
    public getPostings(accountId: string, uCCCorrelationId?: string, size?: number, page?: number, dateType?: 'postingDate' | 'transactionDate', fromDate?: string, toDate?: string, minAmount?: number, maxAmount?: number, includeStatementTransactions?: boolean, merchantCategoryCode?: Array<number>, isSettled?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<any> {
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling getPostings.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>size, 'size');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dateType, 'dateType');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>fromDate, 'fromDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>toDate, 'toDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>minAmount, 'minAmount');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>maxAmount, 'maxAmount');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>includeStatementTransactions, 'includeStatementTransactions');
        if (merchantCategoryCode) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...merchantCategoryCode].join(COLLECTION_FORMATS['csv']), 'merchantCategoryCode');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>isSettled, 'isSettled');

        let localVarHeaders = this.defaultHeaders;
        if (uCCCorrelationId !== undefined && uCCCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('UCC-Correlation-Id', String(uCCCorrelationId));
        }

        // authentication (BearerRead) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerRead', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json; charset=utf-8'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/transactions/postings/${this.configuration.encodeParam({name: "accountId", value: accountId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PostingsList>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns transaction details like travel information
     * @param accountId Unique account ID
     * @param transactionId Transaction ID to look up additional information (if present)
     * @param uCCCorrelationId identifier used for correlating requests
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPostingsDetails(accountId: string, transactionId: string, uCCCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<TransactionDetails>;
    public getPostingsDetails(accountId: string, transactionId: string, uCCCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<HttpResponse<TransactionDetails>>;
    public getPostingsDetails(accountId: string, transactionId: string, uCCCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<HttpEvent<TransactionDetails>>;
    public getPostingsDetails(accountId: string, transactionId: string, uCCCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<any> {
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling getPostingsDetails.');
        }
        if (transactionId === null || transactionId === undefined) {
            throw new Error('Required parameter transactionId was null or undefined when calling getPostingsDetails.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (uCCCorrelationId !== undefined && uCCCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('UCC-Correlation-Id', String(uCCCorrelationId));
        }

        // authentication (BearerRead) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerRead', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json; charset=utf-8'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/transactions/postings/${this.configuration.encodeParam({name: "accountId", value: accountId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "transactionId", value: transactionId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TransactionDetails>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get postings for one or multiple accounts of one customer.
     * @param accountIds List of AccountIds for which postings are returned
     * @param uCCCorrelationId identifier used for correlating requests
     * @param size maximal size of result list (1..1000)
     * @param page Page number, e.g. 4
     * @param dateType Type of date used for \&#39;fromDate\&#39; and \&#39;toDate\&#39;. (default if type is not set: postingDate).  If both \&#39;fromDate\&#39; and \&#39;toDate\&#39; are not provided, then a default time period is used. For the default time period the \&#39;toDate\&#39; is set to current date.  The \&#39;fromDate\&#39; is set to two years ago at the end of the previous month. If current date is e.g. 2024-10-25, then \&#39;fromDate\&#39; is set to 2022-09-30. The sorting of the returned list of transactions is conducted according to the provided dateType in descending order.
     * @param fromDate Only include postings with date greater than or equal to this date, e.g. 2018-04-10
     * @param toDate Only include postings with date up to or equal to this date, e.g. 2018-06-23
     * @param minAmount Only include postings with a posting amount greater than or equal to this amount. The transaction amount may differ, for instance if it is in a different currency.
     * @param maxAmount Only include postings with a posting amount less than or equal to this amount. The transaction amount may differ, for instance if it is in a different currency.
     * @param includeStatementTransactions If this parameter is not specified or false, then only postings for the given account ID are returned. If true, postings on the statement of this account are also returned. These could be transactions of child accounts for which this is the liable account. If this parameter is true, \&#39;fromDate\&#39; and \&#39;toDate\&#39; must have a value. In case that both \&#39;fromDate\&#39; and \&#39;toDate\&#39; are not provided, the default time period is used. For more details see description of the attribute \&#39;dateType\&#39;.
     * @param merchantCategoryCode Only include postings where the merchant category code is contained in the given array.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPostingsFromMultipleAccountIds(accountIds: Array<string>, uCCCorrelationId?: string, size?: number, page?: number, dateType?: 'postingDate' | 'transactionDate', fromDate?: string, toDate?: string, minAmount?: number, maxAmount?: number, includeStatementTransactions?: boolean, merchantCategoryCode?: Array<number>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<PostingsList>;
    public getPostingsFromMultipleAccountIds(accountIds: Array<string>, uCCCorrelationId?: string, size?: number, page?: number, dateType?: 'postingDate' | 'transactionDate', fromDate?: string, toDate?: string, minAmount?: number, maxAmount?: number, includeStatementTransactions?: boolean, merchantCategoryCode?: Array<number>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<HttpResponse<PostingsList>>;
    public getPostingsFromMultipleAccountIds(accountIds: Array<string>, uCCCorrelationId?: string, size?: number, page?: number, dateType?: 'postingDate' | 'transactionDate', fromDate?: string, toDate?: string, minAmount?: number, maxAmount?: number, includeStatementTransactions?: boolean, merchantCategoryCode?: Array<number>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<HttpEvent<PostingsList>>;
    public getPostingsFromMultipleAccountIds(accountIds: Array<string>, uCCCorrelationId?: string, size?: number, page?: number, dateType?: 'postingDate' | 'transactionDate', fromDate?: string, toDate?: string, minAmount?: number, maxAmount?: number, includeStatementTransactions?: boolean, merchantCategoryCode?: Array<number>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json; charset=utf-8', context?: HttpContext}): Observable<any> {
        if (accountIds === null || accountIds === undefined) {
            throw new Error('Required parameter accountIds was null or undefined when calling getPostingsFromMultipleAccountIds.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (accountIds) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...accountIds].join(COLLECTION_FORMATS['csv']), 'accountIds');
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>size, 'size');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dateType, 'dateType');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>fromDate, 'fromDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>toDate, 'toDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>minAmount, 'minAmount');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>maxAmount, 'maxAmount');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>includeStatementTransactions, 'includeStatementTransactions');
        if (merchantCategoryCode) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                [...merchantCategoryCode].join(COLLECTION_FORMATS['csv']), 'merchantCategoryCode');
        }

        let localVarHeaders = this.defaultHeaders;
        if (uCCCorrelationId !== undefined && uCCCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('UCC-Correlation-Id', String(uCCCorrelationId));
        }

        // authentication (BearerRead) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerRead', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json; charset=utf-8'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/transactions/postings`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PostingsList>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
